(function (window, $, app) {
    var Array = window.Array;
    var JSON = window.JSON;
    var document = window.document;
    
    function Nav() {
        var _this = this;
        
        this.toggle = function (nav) {
            var $nav = $('#' + nav).parent();
            var $collapse = $nav.find('.nav\\/collapse');
            var $toggle = $nav.find('.nav\\/collapsed\\/item .toggle-icn');
            
            $toggle.toggleClass('--active');
            $collapse.slideToggle(app.ANIMATION_DURATION, function () {
                var $this = $(this);
                var regex = /(.*)display:\s*none;(.*)/;
                var matches = $this.attr('style').match(regex);
                
                if (matches) {
                    var style = matches[1] + matches[2];
                    
                    $this.attr('style', style);
                }
            });
        };
    }
    
    app.Nav = new Nav();
})(window, jQuery, BreastCancerCare);
